import React from 'react';
import { kitHighlights } from '../data/kit';
import { Section, SectionHeader } from './Shared';
import { Pumpkin, Star } from './HalloweenDecor';
export function KitOverview() {
  return <Section id="contenido" tone="cream" decor={<>
          <Pumpkin className="absolute right-[5%] top-12 w-12 text-brand-orange/20 md:w-16" data-id="element-138" data-mp="uga9wbe38z10" />
          <Star className="absolute left-[7%] top-24 w-4 text-brand-orange/40" data-id="element-139" data-mp="ze1yowjfs50z" />
        </>} data-id="element-137" data-mp="uepgwq7f9o59">
      <SectionHeader tag="🎃 UN KIT, DOS FORMAS DE VIVIR HALLOWEEN" tagVariant="white" title="2 tomos principales + 5 bonus de regalo" subtitle="140 páginas para elegir un disfraz, preparar los materiales y disfrutar el proceso juntos." data-id="element-140" data-mp="1n4fsosll0dy7" />
      <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-brand-ink/85 md:text-lg" data-id="element-141" data-mp="1d7ba12qy30m5">
        Hay chicos que aman los monstruos y otros que prefieren algo simpático. Por eso reunimos propuestas tenebrosas y
        divertidas: para que cada familia elija lo que le guste y se sienta cómoda.
      </p>

      <ul className="mx-auto mt-10 grid max-w-4xl overflow-hidden rounded-3xl bg-brand-violet text-center sm:grid-cols-3" data-id="element-142" data-mp="14nf6sjzitr6k">
        {kitHighlights.map(item => <li key={item} className="border-b border-white/10 px-6 py-6 font-display text-xl font-bold leading-tight text-brand-cream last:border-b-0 sm:border-b-0 sm:border-r sm:last:border-r-0 md:text-2xl" data-id="element-143" data-mp="zqou86mxddpw">
            {item}
          </li>)}
      </ul>
    </Section>;
}